import MuiCardHeader, { CardHeaderProps } from "@mui/material/CardHeader";

const CardHeader: React.FC<CardHeaderProps> = MuiCardHeader;

export default CardHeader;
export type { CardHeaderProps };
